import { DeviceType } from '@/src/types/deviceType'
import { Box, Skeleton } from '@mui/material'

const AirlineFilterShimmer: React.FC<{ deviceType: DeviceType }> = ({ deviceType = 'MOBILE' }) => (
    <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }} alignItems="center">
        <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: 1 }} />
        <Box alignItems="center" display="flex" gap={1} justifyContent="center" flex={1}>
    {[...Array(deviceType === 'MOBILE' ? 4 : 6)].map((_, i) => (
        <Skeleton key={i} variant="rounded" width={110} height={30} sx={{ borderRadius: 1 }} />
    ))}
</Box>
        <Skeleton variant="rounded" width={20} height={20} sx={{ borderRadius: 1, ml: 'auto' }} />
    </Box>
)
export default AirlineFilterShimmer
